import { UseFormReturn } from "react-hook-form";
import { FormContent } from "./App";
import { RefObject, useEffect } from "react";

export function timeAgo(timestampMs: number): string {
    const now = Date.now();
    const diffMs = now - timestampMs;

    if (diffMs < 0) return 'in the future';

    const seconds = Math.floor(diffMs / 1000);
    if (seconds <= 60) {
        return 'just now';
    }

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
        return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    }

    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
        return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    }

    const days = Math.floor(hours / 24);
    return `${days} day${days !== 1 ? 's' : ''} ago`;
}
export const handleRemoveExistsMedia = async (key: string,
    form: UseFormReturn<FormContent, unknown, FormContent>, formData: FormContent) => {
    const keys = formData.mediaKeys?.filter((item) => item !== key) ?? [];
    form.setValue("mediaKeys", keys);
}
export const handleRemoveFile = async (file: File, form: UseFormReturn<FormContent, unknown, FormContent>) => {
    const mediaFiles = form.getValues("mediaFiles") as FileList;
    const files = Array.from(mediaFiles);
    const newFiles = files.filter((item) => (item.name !== file.name && item.size !== file.size));
    const dt = new DataTransfer();
    newFiles.forEach(file => dt.items.add(file));
    form.setValue("mediaFiles", dt.files);
}
export const appendNewFiles = async (
    form: UseFormReturn<FormContent, unknown, FormContent>,
    existingFiles: File[],
    newFiles: File[]
) => {
    const mediaMimePattern = /^(image|video)\//;
    const dataTransfer = new DataTransfer();

    const filteredNewFiles = newFiles.filter(file => mediaMimePattern.test(file.type));
    const newFileNames = new Set(filteredNewFiles.map(file => file.name));

    existingFiles
        .filter(file => !newFileNames.has(file.name))
        .forEach(file => dataTransfer.items.add(file));

    newFiles.forEach(file => dataTransfer.items.add(file));
    form.setValue("mediaFiles", dataTransfer.files);
};
export const handleFilesChange = async (e: React.ChangeEvent<HTMLInputElement>,
    form: UseFormReturn<FormContent, unknown, FormContent>) => {
    const files = Array.from(e.target.files ?? []);
    const existingFiles = Array.from(form.getValues("mediaFiles") ?? []);
    appendNewFiles(form, existingFiles, files);
}

export function useClickOutside<T extends HTMLElement>(
    ref: RefObject<T | null>,
    callback: () => void,
    excludedClass?: string
): void {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (ref.current && ref.current.contains(target)) return;
            if (excludedClass && target.closest(`.${excludedClass}`)) return;
            callback();
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback, excludedClass]);
}